import { useState } from "react";
import axios from "axios";
import image from "../images/logo.png";
import Mainmenu from "./Mainmenu";

function Frame1() {
  const [name, setName] = useState("");
  const [showButton, setShowButton] = useState(false);
  const [showFrame3, setShowFrame3] = useState(false);
  const [showButton1, setShowButton1] = useState(false);
  const [mobilenumber, setMobilenumber] = useState("");
  const [showFrame5, setShowFrame5] = useState(false);

  const handleFocus = () => setShowButton(true);
  const handleFocus1 = () => setShowButton1(true);

  const handleSubmit = (e) => {
    e.preventDefault(); // Move to the beginning

    if (name.trim().length === 0) {
      alert("Please Enter Your Name");
      return;
    }

    setShowFrame3(true);
    setShowButton(false);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^[A-Za-z\s]*$/.test(value)) {
      setName(value);
    } else {
      alert("Please enter a valid name");
    }
  };

  const handleChange1 = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setMobilenumber(value);
    } else {
      alert("Please enter a valid number");
    }
  };

  const handleSubmit1 = async (e) => {
    e.preventDefault(); // Move to the beginning

    if (mobilenumber.length !== 10) {
      alert("Phone number must be exactly 10 digits");
      return;
    }

    try {
      const response = await axios.post("https://poultry-chatbot-api.onrender.com/register", {
        name,
        mobilenumber,
      });

      if (response.status === 200 && response.data.message === "Registration successful") {
        setShowFrame5(true);
      } else {
        alert("Failed to register. Please try again.");
      }
    } catch (error) {
      alert("Error: " + (error.response?.data?.error || "Failed to connect to the server."));
    }
  };

  return (
    <>
      <div className="frame1 animated-frame">
        <img src={image} className="IMAGE" alt="img" />
        <div className="box1">
          I am Suguna Foods
          <img src={image} className="avatar" alt="avatar" />, your virtual assistant!
          May I know your name please?
          <input
            type="text"
            placeholder="Please fill in this field"
            className="text1"
            value={name}
            onChange={handleChange}
            onFocus={handleFocus}
          />
          {showButton && (
            <button className="btn btn-primary p-0 button" onClick={handleSubmit}>
              Submit
            </button>
          )}
        </div>
      </div>

      {showFrame3 && (
        <>
          <div className="frame1 animated-frame">
            <img src={image} className="IMAGE" alt="img" />
            <div className="box1">
              Kindly share your mobile number
              <input
                type="text"
                placeholder="Enter Mobile Number"
                value={mobilenumber}
                onChange={handleChange1}
                className="text1"
                onFocus={handleFocus1}
                required
              />
              {showButton1 && (
                <button className="btn btn-primary p-0 button" onClick={handleSubmit1}>
                  Submit
                </button>
              )}
            </div>
          </div>

          {showFrame5 && (
            <div>
              <Mainmenu />
            </div>
          )}
        </>
      )}
    </>
  );
}

export default Frame1;
  